module.exports = __webpack_public_path__ + "static/media/gale.c31abbd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/gale.png
// module id = 206
// module chunks = 0